module.exports = __webpack_public_path__ + "img/tu02.c87d2204.jpg";